import { analyticsClient, getDatabaseContainerType } from '@databases/analytics';

export const defaultMessageActionByOperationType: Record<'create' | 'edit', string> = {
  create: 'aifc-confluence-database-create',
  edit: 'aifc-confluence-database-update'
};

export const fireAIResultActionedEvent = async ({
  contentId,
  messageAction,
  totalElements,
  remainingElements,
  singleInstrumentationID
}: {
  contentId: string;
  messageAction: string;
  totalElements: number;
  remainingElements: number;
  singleInstrumentationID: string;
}): Promise<void> => {
  const databaseContainer = getDatabaseContainerType();
  await analyticsClient.sendAIResultActionedEvent({
    contentId,
    messageAction,
    databaseContainer,
    totalElements,
    remainingElements,
    singleInstrumentationID
  });
};
